import gql from 'graphql-tag'

export const GET_VEHICLES_INSPECTION = gql`
  query VehicleInspections($filter: GetVehicleInspectionsFilter) {
  vehicleInspections(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    vehicleInspections {
      data {
        inspectionId
        companyId
        templateId
        versionId
        code
        templateVersion {
          snapshot
          current
        }
        templateName {
          snapshot
          current
        }
        isHealthy
        vehicleId
        licensePlate {
          snapshot
          current
        }
        inspectorId
        inspectorName {
          snapshot
          current
        }
        submittedAt
        stats {
          totalQuestion
          totalHealthyAnswer
          totalUnhealthyAnswer
          totalEmptyAnswer
        }
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
        actualTotal
      }
    }
  }
}
`

export const GET_VEHICLE_INSPECTION = gql`
query VehicleInspection($filter: GetVehicleInspectionFilter!) {
  vehicleInspection(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    vehicleInspection {
      inspectionId
      companyId
      templateId
      versionId
      code
      isTemplateDeleted
      templateVersion {
        snapshot
        current
      }
      templateName {
        snapshot
        current
      }
      isHealthy
      vehicleId
      licensePlate {
        snapshot
        current
      }
      inspectorId
      inspectorName {
        snapshot
        current
      }
      submittedAt
      stats {
        totalQuestion
        totalHealthyAnswer
        totalUnhealthyAnswer
        totalEmptyAnswer
      }
      sections {
        name
        questions {
          question
          answer {
            inspectionId
            isHealthy
            questionId
            textValue
            note
            totalPhoto
            photos
            isHealthyValue
          }
        }
      }
    }
  }
}
`
